export class PERMISSIONS {
    //GENERAL PERMISSIONS
    public static ADMIN_PAGES = 'a025bdad-7604-4a08-b393-f8f15e708311'
    public static CUSTOMER_ADMIN_PAGE = '83d52dff-4d1c-46a4-863a-5cf8df4ec635'
    public static USER_ADMIN_PAGE = '4030f548-cbcc-4ccd-9c25-db6855fe050d'
    public static ASSET_ADMIN_PAGE = '89d369a4-2119-4407-92e1-54892af167e7'
    public static INSPECTION_TYPES_PAGE = 'f657052d-f194-4ccb-ae07-29995e6a6c94'
    public static ACTION_TYPES_PAGE = '850f71e7-5da1-478e-924e-7cdbabf1af3b'
    public static MACHINE_LEARNING_PAGE = '879e37fe-7694-44cd-8512-3a023d2c1b7d'
    public static OFFLINE_STORAGE_PAGE = '67c0fe22-af93-4010-957a-7fc58a7143da'
    public static ANOMALIES_PAGE = '9339b91d-6720-4d97-8223-a191672dc7cf'
    public static SCHEDULE_PAGE = 'c647b2c3-e6b4-419b-870f-c9baebbe8956'
    public static DASHBOARD_PAGE = 'bc416fe5-6b97-4e8f-9a39-9080f2e84b10'
    public static SENSORS_PAGE = '1efcf06a-28a3-4d5b-bab0-130b0f4ed2ca'
    public static EDIT_CUSTOMER = "10587ba2-8b31-433e-a215-c27e4f4c4140"
    public static DELETE_CUSTOMER = "645d8b64-4929-4f20-8b80-822cdb5fd3c2"
    public static CREATE_CUSTOMER = "2d94a642-e972-4b62-a612-2f6c86688df8"
    public static EDIT_USER = "677bf10f-aa03-4243-a76b-c77101313de1"
    public static DELETE_USER = "f2699b71-5d2f-4c3b-851e-4676b90db0bd"
    public static CREATE_USER = "fa5727f4-c7a9-43b8-914c-9bceb5c7c0ea"
    public static UTILITIES = "2b8f5923-a996-495b-b5a8-19b549c9a2d7"
    public static DELETE_RELEASENOTES = "81b58eba-36d5-4cff-966b-2a709ceb1c19"
    public static CREATE_RELEASENOTES = "ca223085-39fa-4cce-8a56-ae3182d36092"
    public static EDIT_RELEASENOTES = "9ed8eb9c-bf39-468c-bb3f-7e062e6f8b56"
    public static TRACING_PAGE = "20a3a51a-fc89-4654-8afc-fe69f6ae4477"
    public static RISK_PAGE = "c33f3812-af6f-4484-aecc-a5bfc1c053c6"
    public static DEGRADATION_STATISTICS_PAGE = "6a7f14ce-7e51-41c4-8e43-84355d1ca06d"
    public static STABILITY = "b2b0b2a0-4b0a-4b0a-8b0a-4b0a4b0a4b0a"
    public static ELEMENTS_PAGE = "a6d5d0f2-8d0f-4c8b-8c2e-6e7f7e2c5c7b"
    public static RISK_SETUP_PAGE = "2e36b36a-eff2-47a0-92f0-e210277f3b34"
    public static FEA_PAGE = "34aa94db-3d40-449d-b3f9-fe2a31f8a67e"
    public static AGENTIC_PANEL = "55cdb20c-467f-4ccd-81d3-73fef1d4fd60"
    public static GENERATE_TANK_FROM_SCOUT = "b9e7c4a1-2f63-4d58-9a0c-7e1f5b3d2c84"



    //ASSETS PERMISSIONS
    public static INSERT_INSPECTIONS = '7a1f503f-71f7-4112-a8f4-550434c41682'
    public static SEND_DRONE_IMAGE = 'e0f6a194-9894-437e-8a84-15d4b78817b9'
    public static INSERT_REPAIR = '3d8c5dd2-5399-4098-8a12-970b09b126e0'
    public static INSERT_DOCUMENT = '0d68f1a8-042e-44a4-95ae-fc86ec3d2145'
    public static EDIT_PROPERTIES = '3f77339b-d575-46d4-8275-f2776141d64c'
    public static FEA_FUNCTIONS = 'fc904a43-3897-48ee-813a-0edb2c0b7c11'
    public static EDIT_ANOMALIES = '4625db8f-5172-4e77-baf4-10ce9543a2f6'
    public static RUN_NASTRAN = 'd720f010-24d4-42e5-ab03-88015883db6f'
    public static FILTERS = "1c244df1-36a9-49ea-9be6-337775982565"
    public static CHANGES_APPROVER = "ae5a0321-8de2-48a3-bf54-8832bd9680f1"
    public static APPROVE_SCHEDULE = "739b4fc1-07e3-4bea-a4d0-8d3993ded571"
    public static LOCK_CLUSTER_ELEMENTS = "9f0cb7a2-f346-4f1e-a737-c25e0899182d"
    public static INSERT_PROTECTION_ELEMENTS = "a787d634-df92-4091-b0aa-77ebc435a5f6"
    public static VIEW_PROTECTION_ELEMENTS = "f68bbfd6-f7c4-43fc-918e-89494e587137"
    public static DELETE_PROTECTION_ELEMENTS = "4b023c98-0f8a-4842-a41a-96a09e439d6b"
    public static DEGRADATION = "2c1c9615-f769-43b7-a9aa-f0676a235101"
    public static INSERT_CRITICAL_AREA = "775ccac7-4e7d-4317-9c7b-88f5db14a1aa"
    public static RISK_SHIELD = "2aea507c-1bd7-4f9a-99c4-c4c305dc9d96"
    public static OFFLINE_INSPECTION_APPROVER = "ee60d069-3aff-4912-8ed0-5358b936f4d9"
    public static REAPPLY_ELEMENTS = "8fcb69ea-d728-4179-ac72-d363e21287ed"
    public static SHOW_CREATE_SENSORS = "27e9f7b3-5307-4eca-8455-b95bf91b078b"
    public static EDIT_TRACKED_ELEMENTS = "f9bc9d8f-d6c4-4b84-8a24-9ce1763d613f"
    public static VIEW_TRACKED_ELEMENTS = "a65e0502-dbe6-4bf2-8612-7f2016958f65"
    public static IMAGE_OVERLAY = "7f34011f-a57d-405b-a342-8d76e10d3c5b"
    public static DISMANTLE = "9fd39a85-fe68-453b-9836-a3324832e4f6"
    public static SHOW_CONSEQUENCE_MAP = "0e235922-a709-4b3b-9aab-4f9b29c901ae"
    public static SHOW_RISK_ASSESSMENT = "005e4468-1978-4d5a-b409-252eb5567054"
    public static SHOW_REPORTS = "952ff4a6-bd26-487a-8d02-98663bea0677"
    public static SHOW_CALC_MEMORANDUM = "6e61df65-9d4b-4086-9da8-5b3ab931b74a"
    public static SHOW_FEA_RESULTS = "37aa6dc3-9dd3-4e4d-af0b-a430a34f4e86"
    public static SHOW_DLA_RESULTS = "83529619-989f-4650-b284-336b332633bd"
    public static SHOW_FLOATING_DRY_DOCK_RESULTS = "483e67c1-90f2-4aaa-9c1e-12d5d4a03b3f"
    public static COMPUTE_DIMENSIONS = "d1009c44-ed2b-4803-a233-7e49e72d8c60"
    public static REFERENCE_LINES = "475c4730-e902-41f6-b6a6-92bf1305a572"
    public static DELETE_ELEMENT = "cf8aa94d-4fe3-4f83-a4cd-800e5144d48b"
    public static SHOW_SOFTWARE_MANUAL = "82e699a2-4898-41e5-b5ce-27a4a0f9a175"
    public static EDIT_FEA_WORKFLOW = "b45b15b6-970a-43cb-a5cf-d43d5d7bd817"
    public static SHOW_ALL_FEA_RUN_DETAILS = "383cedec-867c-403e-8523-13d0eb9fe9cf"
    public static MANAGE_FEA_CONNECTIONS = "45fa77a5-cfbb-424d-90ec-0379a65e82ac"
    public static SHOW_FATIGUE_RESULTS = "7a07f870-a104-435d-8549-35368512609d"
    public static VIEW_PULSE_IF_ENABLED = "9108a3de-d375-49f0-9165-b6f645bd2a95"
    public static VIEW_SUBMODEL_NAVIGATION_MENU = "f57f8811-b343-492f-8a18-f7d82f7f90c4"
    public static CHANGE_MATERIAL = "14e2af2e-784b-4da1-a110-97fa05ac8896"
    public static EMAIL_PERMISSION_FOR_ERRORS = "d8e1580f-2ca7-46ea-a188-3c59e5fe26da"


    public static BUILD = "e46336e8-6cf8-40a0-801f-a75f8dd300da"
    public static LOADCYCLECORROSION = "f0a19cf7-14c4-4b87-a68b-76873e0f3bc0"
    public static IMPORT_DRONE_SESSION_DATA = "c7a4e2f1-8b39-4d6e-9f02-1a3c5e7b9d04"
    // "SAW / InSAR" on one asset — the only InSAR gate. A general permission carries the same
    // label (2cf15de4-...) and is not checked; compare by id, never by label
    public static SAW_INSAR_ASSET = "23ffd267-b59d-4338-97d4-78161b1ede10"
}
